import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { JwtModule } from '@auth0/angular-jwt';
import { TokenConstants } from '../assets/constants/token.const';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './common/modules/auth/interceptor/auth.interceptor';
import { FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from 'primeng/editor';
import { RepeatTypeFormlyField } from './common/formly/repeatSectionType';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { ButtonModule } from 'primeng/button';
import { FormlyFieldFile } from './common/formly/file-type/file-type.component';
import { MessageService } from 'primeng/api';
import { CustomDatepickerComponent } from './common/formly/datepicker';
import { CustomDropDownComponent } from './common/formly/dropdown';
import { CustomSwitchComponent } from './common/formly/switch';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MultiselectWrapperComponent } from './common/formly/multiselect';
import { InputFieldTypeWithIcon } from './common/formly/password-view.type';
import { Title } from '@angular/platform-browser';
import { IndexHTMLDetails } from 'src/assets/data/index.html.const';
import { environment } from 'src/environments/environment';
import { InputFieldChipsField } from './common/formly/inputFieldChipType';
import { SelectFieldWithDescription } from './common/formly/selectFieldWithDescription';
import { SubscriptionModulesFormlyField } from './common/formly/subscriptionModules';
import { EditorFieldType } from './common/formly/editor.formly';
import { SearchMultiselectComponent } from './common/formly/multiSelect.formly';
import { ProgressBarModule } from 'primeng/progressbar';
import { LoaderInterceptor } from './common/services/loader/loader.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';

export function tokenGetter() {
  return localStorage.getItem(TokenConstants.TOKEN_KEY);
}

@NgModule({
  declarations: [
    AppComponent,
    EditorFieldType,
    RepeatTypeFormlyField,
    FormlyFieldFile,
    CustomDatepickerComponent,
    MultiselectWrapperComponent,
    CustomSwitchComponent,
    CustomDropDownComponent,
    SelectFieldWithDescription
  ],
  imports: [
    CommonModule,
    FormlyModule.forRoot({
      validationMessages: [{ name: 'required', message: 'This field is required' }],
      types: [
        { name: 'editor', component: EditorFieldType },
        { name: 'multiSelect', component: MultiselectWrapperComponent },
        {
          name: 'searchAutocomplete',
          component: SearchMultiselectComponent
        },
        { name: 'datepicker', component: CustomDatepickerComponent },
        { name: 'switch', component: CustomSwitchComponent },
        { name: 'dropdown', component: CustomDropDownComponent },
        { name: 'repeat', component: RepeatTypeFormlyField },
        { name: 'file', component: FormlyFieldFile },
        { name: 'password-view', component: InputFieldTypeWithIcon },
        { name: 'subscriptionModuleField', component: SubscriptionModulesFormlyField },
        { name: 'inputChip', component: InputFieldChipsField },
        { name: 'autoComplete', component: SearchMultiselectComponent }
      ]
    }),
    AppRoutingModule,
    AppLayoutModule,
    JwtModule.forRoot({
      config: {
        tokenGetter
      }
    }),
    ReactiveFormsModule,
    EditorModule,
    FormlyModule.forRoot({ extras: { lazyRender: true } }),
    FormlyPrimeNGModule,
    ButtonModule,
    FormsModule,
    CalendarModule,
    ToastModule,
    DropdownModule,
    MultiSelectModule,
    InputSwitchModule,
    ProgressBarModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    // {
    //     provide: HTTP_INTERCEPTORS,
    //     useClass: OrganizationInterceptor,
    //     multi: true
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },

    MessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: (titleService: Title) => {
        return () => {
          const activeAppDetails = IndexHTMLDetails.find(
            (app) => app.sibasiApp === environment.activeApp
          );
          if (activeAppDetails) {
            titleService.setTitle(activeAppDetails.title);
            const metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
              metaDescription.setAttribute('content', activeAppDetails.description);
            }
          }
        };
      },
      deps: [Title],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
